import React, { FC } from 'react';
import { Skeleton } from 'src/common';
import BidTaskContent from './BidTaskContent';
import { BidTaskAnswer } from './BidTaskAnswer';
import BidTaskComments from './BidTaskComments';
import { useTask } from 'src/models/bids/BidTask/hooks';
import { GenerateResponseProvider } from 'src/models/biddingGPT/providers';

export const TaskEditor: FC = () => {
  const { loading } = useTask();

  return loading ? (
    <Skeleton active loading />
  ) : (
    <>
      <BidTaskContent />
      <GenerateResponseProvider>
        <BidTaskAnswer />
      </GenerateResponseProvider>
      <BidTaskComments />
    </>
  );
};

export default TaskEditor;
